// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoView_root__SKfWx","selected":"VideoView_selected__x8Xqr","controls":"VideoView_controls__S7xil","inner":"VideoView_inner__cuhsK"};